import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Checkbox, FormControlLabel } from '@mui/material';
import * as lodash from 'lodash';
import { useMemo } from 'react';
export const CheckboxForTree = (props) => {
    const { newSetter, keyResult, setter, onCheckNewConfig, data, name, component, labelForComponent, } = props;
    const keyForDisables = useMemo(() => (keyResult === 'old' ? 'new' : 'old'), [keyResult]);
    return (_jsx(_Fragment, { children: onCheckNewConfig && (_jsx(FormControlLabel, { control: _jsx(Checkbox, { checked: lodash.some(newSetter, {
                    el: { id: setter.id },
                    keyResult: keyResult,
                }), disabled: lodash.some(newSetter, {
                    el: { id: setter.id },
                    keyResult: keyForDisables,
                }), onChange: (event) => onCheckNewConfig(event, {
                    key: data.key,
                    el: {
                        settings: setter.settings,
                        id: setter.id,
                    },
                    keyResult: keyResult,
                    ...(component?.name
                        ? { name: component.name }
                        : name && { name: name }),
                    ...(component?.idSensor && {
                        idSensor: component.idSensor,
                    }),
                    ...(component?.flag && { flag: component.flag }),
                }), color: "secondary" }), label: labelForComponent })) }));
};
